import React from 'react';
import { Progress } from 'antd';
import Label from '../form/Label/Label';
import { FlexContainer } from '../Containers/FlexContainer/FlexContainer';
import './ProgressPotentialDial.scss';
import classnames from 'classnames';

const PotentialDialFormat = props => {
  const { totalCount } = props;
  return (
    <FlexContainer className="flex-column">
      <Label className=" bold fontGray500 m-text-20" tabIndex="-1">
        {totalCount}
      </Label>
    </FlexContainer>
  );
};

const ProgressPotentialDial = props => {
  const {
    totalCurrentTradelineCount,
    delinquentTradelineCount,
    derogatoryTradelineCount,
    porcentTradelineCount,
    className,
    strokeColor,
    successStrokeColor,
    trailColor,
  } = props;

  const totalCount =
    totalCurrentTradelineCount +
    delinquentTradelineCount +
    derogatoryTradelineCount;
  const progressValue1 = derogatoryTradelineCount / (totalCount / 100);
  const progressValue2 = delinquentTradelineCount / (totalCount / 100);
  const width = {
    large: 142,
    medium: 136,
    small: 72,
    ocfMedium: 124,
  };

  let progressClass = classnames('ProgressPotentialDial blue050', className);

  return (
    <div className={progressClass} aria-label="progressbar" role="progressbar">
      <Progress
        type="dashboard"
        percent={progressValue1 + progressValue2}
        success={{
          percent: progressValue2,
          strokeColor: { successStrokeColor },
        }}
        width={props?.size ? width[props?.size] : width['small']}
        aria-label="progressbar"
        gapDegree={0.1}
        trailColor={trailColor}
        strokeColor={strokeColor}
        format={() => (
          <PotentialDialFormat
            totalCount={totalCount || `${porcentTradelineCount}%`}
            {...props}
          />
        )}
      />
    </div>
  );
};

export default ProgressPotentialDial;
